var _excluded = ["group", "keyName", "valueAccessor"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as reductio_ from 'reductio';
import NumberDisplay from './NumberDisplay';
var reductio = reductio_["default"] || reductio_;
export var NumberDisplaySum = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NumberDisplaySum, _Component);

  function NumberDisplaySum() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = NumberDisplaySum.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        group = _this$props.group,
        keyName = _this$props.keyName,
        valueAccessor = _this$props.valueAccessor,
        otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

    var calcSum = reductio().sum(function (d) {
      return d[keyName];
    });
    calcSum(group);
    return /*#__PURE__*/React.createElement(NumberDisplay, _extends({
      id: this.props.id,
      group: group,
      valueAccessor: function valueAccessor(d) {
        return d.sum;
      }
    }, otherProps));
  };

  return NumberDisplaySum;
}(Component);
NumberDisplaySum.propTypes = process.env.NODE_ENV !== "production" ? {
  /** name of the value that `sum` is calculated by formula `reductio().sum(d => d[keyName])`  */
  keyName: PropTypes.string.isRequired,

  /** `crossfilter` group. Set or get the group attribute of a chart. In dc a group is a crossfilter group. Usually the group should be created from the particular dimension associated with the same chart. If a value is given, then it will be used as the new group. */
  group: PropTypes.object.isRequired
} : {};
export default NumberDisplaySum;